import React from "react";
import { TemplateSevenResumeSection } from "./common";
import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "../ResumePDF/common";

const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateSevenResumeSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText>{summary}</ResumePDFText>}
      </View>
    </TemplateSevenResumeSection>
  );
};

export default Summary;
